<template>
  <div>
    <router-view />
    <Footer v-if="footerVisible" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Footer from "@/components/Footer";
export default {
  components: { Footer },
  computed: {
    ...mapState(["navVisible", "footerVisible"]),
  },
};
</script>
